import { useEffect, useState } from 'react'
import { isKalamaBrandingEnabled } from 'src/modules/brand/utils/kalama-branding'
import { KALAMA_NOTICE_PATHS } from 'src/modules/brand/utils/kalama-notice'
import { KalamaNoticeBannerContent } from '../kalama-notice-banner-content'
import { dismissKalamaRenamedBanner, isKalamaRenamedBannerDismissed } from './kalama-renamed-banner.domain'
import type { KalamaRenamedBannerProps } from './kalama-renamed-banner.interface'

export function KalamaRenamedBanner({ path, profile }: KalamaRenamedBannerProps) {
  const accountId = profile?.id
  const [isDismissed, setIsDismissed] = useState(() => readDismissed(accountId))
  const isVisible =
    Boolean(accountId) && !isDismissed && isKalamaBrandingEnabled() && KALAMA_NOTICE_PATHS.includes(path)

  useEffect(() => {
    setIsDismissed(readDismissed(accountId))
  }, [accountId])

  if (!isVisible) return null

  const handleDismiss = () => {
    setIsDismissed(true)
    dismissKalamaRenamedBanner(accountId)
  }

  return (
    <KalamaNoticeBannerContent
      messageId="brand.kalamaRenamed.message"
      linkId="brand.kalamaRenamed.link"
      dismissId="brand.kalamaRenamed.dismiss"
      testId="kalama-renamed-banner"
      onDismiss={handleDismiss}
    />
  )
}

function readDismissed(accountId?: string): boolean {
  return Boolean(accountId) && isKalamaRenamedBannerDismissed(accountId)
}
